import type { Anchor } from "@rally/agreed";
import type { TargetKind } from "../../net/api.ts";
import { withRouting } from "../composer/addressed.ts";

export type MessageAttachment = { key: string; name: string; mediaType: string };
export type MessageRequest = {
  conversation: string;
  text: string;
  replyTo?: { kind: TargetKind; id: string };
  anchor?: Anchor;
  files?: readonly MessageAttachment[];
  apps?: readonly string[];
};

export function routedMessageText(text: string, visibleLikely: readonly string[]): string {
  return withRouting(text, visibleLikely);
}

export function canonicalTypedPayload(request: MessageRequest): object {
  return {
    conversation: request.conversation,
    text: request.text,
    source: "typed",
    call: null,
    replyTo: request.replyTo ?? null,
    anchor: request.anchor ?? null,
    files: (request.files ?? [])
      .map(({ key, name, mediaType }) => ({ key, name, mediaType }))
      .sort(
        (left, right) =>
          left.key.localeCompare(right.key) ||
          left.name.localeCompare(right.name) ||
          left.mediaType.localeCompare(right.mediaType),
      ),
    apps: [...(request.apps ?? [])].sort(),
  };
}
